module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#thump",
      toString: function () {
        return this.url;
      }
    }